import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Field: {
    display: 'grid',
    paddingRight: '10px',
    width: '100%',
  },
  ValueField: {
    marginLeft: '-10px',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  EventTypeForm: {
    borderBottom: '2px solid lightgray',
    '&:hover': {
      '& $EventTypeNameField': {
        backgroundColor: 'rgb(214, 232, 245)',
      },
      '& $RuleFields': {
        backgroundColor: 'rgb(239, 246, 251)',
      },
      '& $RuleButtons': {
        visibility: 'visible',
      },
      '& $DisplayNoneMock': {
        visibility: 'visible',
        height: '36px',
        width: '36px',
        padding: '6px 0',
        margin: '6px 0 31px 0',
      },
      '& $DefaultField': {
        display: 'none',
      },
      '& $AddMemberHidden': {
        visibility: 'hidden',
      },
      '& $Hidden': {
        visibility: 'visible',
      },
    },
  },
  EventTypeName: {
    paddingLeft: '10px',
    wordBreak: 'break-word',
  },
  EventTypeNameField: {
    backgroundColor: '#f1f1f1',
  },
  EventTypeNameHeader: {
    backgroundColor: '#f1f1f1',
  },
  FieldBackground: {
    backgroundColor: 'white',
  },
  TemplateNameRow: {
    backgroundColor: '#f1f1f1',
  },
  RuleFields: {
    paddingLeft: '5px',
  },
  FieldLabel: {
    marginLeft: '6px',
    paddingTop: '6px',
    display: 'grid',
  },
  AccountLabel: {
    paddingTop: '6px',
    display: 'grid',
    marginBottom: '6px',
  },
  RuleButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '10px',
    visibility: 'hidden',
  },
  RuleAccountRow: {
    borderTop: '1px solid lightgray',
  },
  InactiveRule: {
    fontSize: 'larger',
    marginLeft: '10px',
  },
  AddMemberHidden: {
    visibility: 'visible',
  },
  DefaultField: {
    fontStyle: 'italic',
    color: 'gray',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    display: 'block',
    height: '36px',
    marginTop: '6px',
    marginBottom: '31px',
  },
  UsageField: {
    display: 'grid',
  },
  UsageValue: {
    marginLeft: '20px',
    marginBottom: '35px',
    fontSize: '20px',
    textAlign: 'center',
  },
  UsageLabel: {
    marginLeft: '20px',
    textAlign: 'center',
  },
  TemplateFieldMember: {
    paddingLeft: '5px',
    position: 'relative',
    '&:hover': {
      backgroundColor: 'rgb(214, 232, 245)',
      '& $DeleteMemberButton': {
        visibility: 'visible',
      },
    },
  },
  SingleAddMemberButton: {
    marginTop: '6px',
    marginBottom: '31px',
    width: '25%',
  },
  AddMemberButton: {
    paddingLeft: '0px',
    paddingRight: '0px',
    width: '36px',
    minWidth: 'initial',
  },
  DelimiterButton: {
    paddingLeft: '0px',
    paddingRight: '0px',
    width: '36px',
    height: '36px',
    fontSize: '20px',
    minWidth: 'initial',
    backgroundColor: 'white',
  },
  SelectedDelimiter: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    fontWeight: 'bold',
  },
  DeleteMemberButton: {
    position: 'absolute',
    zIndex: '2',
    marginBottom: '60px',
    height: '35px',
    width: '35px',
    visibility: 'hidden',
  },
  AccountNumberField: {
    paddingLeft: '10px',
  },
  NotSelectedOption: {
    color: 'rgb(158, 158, 158)',
  },
  FollowingLabel: {
    color: '#888',
  },
  Delimiter: {
    width: '50px',
  },
  // We can't set display any because of the issues with the Cypress tests,
  // therefore just mock the visibility part of the display none.
  DisplayNoneMock: {
    visibility: 'hidden',
    height: '0px',
    width: '0px',
    margin: '0px',
    padding: '0px',
  },
  Hidden: {
    visibility: 'hidden',
  },
});
